import React from 'react';
import { Link } from 'react-router-dom';
export const TechnologyLinksSection = () => {
  const technologies = [{
    name: 'Laravel',
    icon: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6raD3sQbYhrAYJrpu7Fmsg/Laravel.jpg',
    count: 1240
  }, {
    name: 'Vue.js',
    icon: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ncaFrZrfpfapyV9ExA35DY/Vue_logo.png',
    count: 875
  }, {
    name: 'React',
    icon: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ptv5Wif4YhmkFBsFHL24ST/React.png',
    count: 950
  }, {
    name: 'PHP',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/PHP-logo.svg/1280px-PHP-logo.svg.png',
    count: 1500
  }, {
    name: 'JavaScript',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png',
    count: 1350
  }, {
    name: 'TypeScript',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/1200px-Typescript_logo_2020.svg.png',
    count: 780
  }];
  return <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-128">
      {technologies.map(tech => <Link key={tech.name} to={`/developers?tech=${tech.name}`} className="flex flex-col items-center p-4 bg-white rounded-lg border border-gray-200 hover:shadow-md transition-shadow" data-id="element-129">
          <div className="w-12 h-12 mb-3 flex items-center justify-center" data-id="element-130">
            <img src={tech.icon} alt={tech.name} className="w-full h-full object-contain" data-id="element-131" />
          </div>
          <span className="font-medium text-gray-900" data-id="element-132">{tech.name}</span>
          <span className="text-sm text-gray-500" data-id="element-133">{tech.count} developers</span>
        </Link>)}
    </div>;
};